import React, { useState } from "react";
import { Check, Maximize2, Users, Ruler, BedDouble } from "lucide-react";
import Reveal from "../components/Reveal";
import PageHero from "../components/PageHero";
import { useReservation } from "../components/ReservationModal";
import { rooms, amenities } from "../mock";

const RoomBlock = ({ room, index }) => {
  const [selected, setSelected] = useState(room.cover);
  const { openReservation } = useReservation();
  const reversed = index % 2 === 1;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <Reveal className={reversed ? "lg:order-2" : ""}>
        <div className="img-zoom rounded-sm overflow-hidden shadow-2xl mb-4">
          <img src={selected} alt={room.name} className="w-full h-[440px] object-cover" />
        </div>
        <div className="grid grid-cols-4 gap-3">
          {room.gallery.slice(0, 4).map((img, i) => (
            <button
              key={i}
              onClick={() => setSelected(img)}
              className={`img-zoom rounded-sm overflow-hidden h-20 border-2 transition-all ${
                selected === img ? "border-[#b8893a]" : "border-transparent"
              }`}
            >
              <img src={img} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </Reveal>

      <Reveal delay={150} className={reversed ? "lg:order-1" : ""}>
        <p className="eyebrow text-[#b8893a] mb-3">Konaklama</p>
        <h2 className="font-display text-4xl md:text-5xl text-[#2b2620] font-500 mb-4">{room.name}</h2>
        <p className="text-[#6b6459] leading-[1.9] text-[15px] mb-7">{room.short}</p>

        <div className="grid grid-cols-3 gap-4 mb-7">
          {[
            { icon: Ruler, label: room.size },
            { icon: Users, label: room.capacity },
            { icon: BedDouble, label: room.bed },
          ].map((s, i) => (
            <div key={i} className="bg-[#f6f0e6] px-4 py-4 rounded-sm text-center">
              <s.icon size={19} className="text-[#b8893a] mx-auto mb-2" />
              <p className="text-[12px] text-[#4a443b] font-500">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-2.5 mb-8">
          {room.features.map((f, i) => (
            <div key={i} className="flex items-center gap-2">
              <Check size={15} className="text-[#b8893a] shrink-0" />
              <span className="text-[13px] text-[#4a443b]">{f}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-6 border-t border-[#e9e0cf] pt-6">
          <div>
            <span className="font-display text-3xl text-[#2b2620] font-600">{room.price}</span>
            <span className="text-[12px] text-[#6b6459] ml-2">/ {room.priceNote}</span>
          </div>
          <button onClick={() => openReservation(room.id)} className="btn-gold px-8 py-3.5 rounded-sm ml-auto">
            Rezerve Et
          </button>
        </div>
      </Reveal>
    </div>
  );
};

const Rooms = () => {
  return (
    <div className="font-body">
      <PageHero
        image={rooms[0].gallery[2]}
        eyebrow="Safranbolu Çelebi Otel"
        title="Odalarımız"
        subtitle="Rahatınız ve konforunuz için gerekli her şey özenle düşünüldü."
      />

      {/* Amenities strip */}
      <section className="bg-[#2b2620] py-6">
        <div className="max-w-7xl mx-auto px-5 md:px-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {amenities.slice(0, 6).map((a, i) => (
            <span key={i} className="text-white/70 text-[13px] tracking-wide flex items-center gap-2">
              <span className="w-1 h-1 bg-[#d9b877] rounded-full" /> {a.title}
            </span>
          ))}
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[#fdfbf7]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 space-y-24 md:space-y-32">
          {rooms.map((room, i) => (
            <RoomBlock key={room.id} room={room} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Rooms;
